import styled from 'styled-components'
import { containerExpanded } from '../../lib/styles/Container'
import { StyledHelpList } from '../../components/UI/HelpListItem'
import { StyledButton } from '../../components/UI/Button/styled'
import PhoneInput from 'react-phone-input-2'
import { TextInput } from '../../components/UI'

export const StyledWrapper = styled.div<{
  marginBlock?: string
}>`
  ${containerExpanded};
  margin: 3rem auto;
`

export const TextInputHidden = styled.div`
  display: none;
`

export const StyledPhoneInput = styled(PhoneInput)`
  &.react-tel-input {
    .form-control {
      border: 0;
      border-radius: 0.6rem;
      font-size: 0.9rem;
      height: 2.9rem;
      line-height: 1;
      outline: 0;
      transition: all 0.2s;
      width: 100%;
      background: rgba(255,255,255,.6);
      color: #0D0D0D;
    }
    
    .flag-dropdown {
      background: transparent;
      border: 0;
      
      &.open {
        border-radius: 0.6rem 0 0 0.6rem;

        .selected-flag {
          border-radius: 0.6rem 0 0 0.6rem;
        }
      }
      .selected-flag {
        border-radius: 0.6rem 0 0 0.6rem;
      }
    }
  }

`

export const StyledPanel = styled.div`
  align-items: center;
  background-color: var(--c-theme-6);
  border-radius: 1.5rem;
  padding: 4rem;

  @media screen and (max-width: 992px) {
    padding: 3rem;
  }

  @media screen and (max-width: 480px) {
    align-items: unset;
    flex-direction: column;
    gap: 0.5rem;
    padding: 2rem;
  }
`

export const StyledBody = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 4rem;

  @media screen and (max-width: 860px) {
    flex-direction: column;
    gap: 3rem;
  }
`

export const StyledHeader = styled.div`
  display: flex;
  margin-bottom: 2rem;

  @media screen and (min-width: 860px) {
    & > * {
      flex: 0.66;
      padding-right: 4rem;
    }
  }
`

export const StyledForm = styled.form`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.5rem;

  ${StyledButton} {
    align-self: flex-start;
    margin-top: 1.5rem;
  }
`

export const StyledInputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  @media screen and (min-width: 860px) {
    flex-direction: row;
  }

  & > * {
    flex: 1;
  }
`

export const StyledContactInformations = styled.div`
  align-items: flex-start;
  display: flex;
  flex: 0.34;
  flex-direction: column;
  gap: 0.5rem;

  &.prose > p,
  &.prose > ${StyledHelpList} {
    margin-bottom: 0;
    margin-top: 0;
  }
`

export const StyledSuccessMessage = styled.p`
  white-space: pre-line;
`

export const StyledErrorMessage = styled.p`
  color: ${({ theme }) => theme.colors.red[3]};
  font-size: 0.7rem;
  font-weight: 600;
  margin-top: 0.6rem;
`
